<template>
  <div class="page">
    <div class="content">
      <el-tabs class="tabs" v-model="activeName">
        <el-tab-pane name="first">
          <span slot="label" class="label"><img class="label_icon" src="../../assets/douyin.png" alt="" />
            抖音达人</span>
            <First @changeFatherMarketingTarget="changeFatherMarketingTarget"
                    @changeQuery="changeQuery" @changeTableVideoData="changeTableVideoData">
            </First>
        </el-tab-pane>
      </el-tabs>
      <Table1 v-if="activeName==='first'" :marketing_target="marketing_target"
             :commonQuery="commonQuery" 
             :tableVideoData="tableVideoData" 
             @changeQuery="changeQuery">
      </Table1>

    </div>
  </div>
</template>

<script>
  import First from './tabs/first.vue'
  import Table1 from './table/table1.vue'
    // import Second from './tabs/second.vue'
    // import Table2 from './tabs/table2.vue'
  export default {
    data() {
      return {
        activeName: "first",
        //tab1
        marketing_target: 1,
        tableVideoData:'',
        commonQuery:{},
        //tab1 end
      };
    },
    created() {
      if (window.performance.navigation.type === 0 || window.performance.navigation.type === 1 || window.performance
        .navigation.type === 2) {
        //判断浏览器刷新行为，清除session
        let inSalesGroup = window.sessionStorage.getItem('inSalesGroup')
        let name = window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup', inSalesGroup)
        window.sessionStorage.setItem('name', name)
      }
    },
    watch: {
      activeName: {
        handler(val){
          switch (val) {
            case 'first':
              localStorage.setItem('plat', 'dy')
              break;
            default:
              break;
          }
        },
        immediate: true
      }
    },
    components:{
      First,
      Table1
    },
    methods: {
      changeFatherMarketingTarget(val){
        this.marketing_target=val
      },
      changeQuery(query,which){
        this.commonQuery = query
      },
      changeTableVideoData(videoQuery){
        this.tableVideoData = videoQuery
      },
      enterHelper() {
        let routeData
        if(this.activeName==='first'){
          routeData = this.$router.resolve({
            path: '/ai',
          })
        }
        window.open(routeData.href, "_blank");
      },
    },
    mounted(){}
  };
</script>